import { useCallback, useState } from 'react';
import { User, useUserObject } from '../context/UserContext';
import { getUser } from '../services/User';
import * as Sentry from '@sentry/react';

export default function useUser(): {
  loadUser: (signal?: AbortSignal) => Promise<void>;
  user: User | null;
  setUser: (user: User | null) => void;
  loading: boolean;
} {
  const [loading, setLoading] = useState<boolean>(false);
  const { setUser, user } = useUserObject();

  const loadUser = useCallback(
    async (signal?: AbortSignal) => {
      setLoading(true);
      try {
        const user = await getUser(signal);

        setUser(user);
        Sentry.setUser({ email: user.email, id: String(user.id) });

        return Promise.resolve();
      } catch (e) {
        if (!signal?.aborted) {
          setUser(null);
          Sentry.setUser(null);
          return Promise.reject();
        }
      } finally {
        setLoading(false);
      }
    },
    [setUser],
  );

  return {
    loadUser,
    user,
    setUser,
    loading,
  };
}
